// flow weak

import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  InputGroup,
  Glyphicon,
  Image,
  ListGroup,
  ListGroupItem,
  Carousel,
  Tabs,
  Tab,
  Alert,
  Checkbox,
  Modal,
  Table
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
import { withRouter, Link } from "react-router-dom";

import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";

import "./dashboard.scss";
import {
  getDealList,
  currentDealList,
  dealDetail,
  addToCart,
  generateCoupon
} from "../../../redux/actions/frontActions";
import logo from "../../../img/ddb-logo.png";
import bannerImg from "../../../img/2006380_YyczUn.png";
import noImg from "../../../img/no_img.jpg";
import dealImg from "../../../img/Deal-Photo.jpg";
import "react-responsive-tabs/styles.css";
import noRecordFound from "../../../img/no-record-found.png";
import ReactHtmlParser from "react-html-parser";

import { geolocated } from "react-geolocated";
import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";

import { Notification } from "../../../components/notifications";

import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";

import {
  FacebookShareButton,
  FacebookIcon,
  TwitterIcon,
  TwitterShareButton,
} from 'react-share';

import moment from "moment";

import Cookies from "universal-cookie";
import Reviews from "./Reviews.js";
import ReviewList from "./ReviewList.js";
import Question from "./Question.js";

const cookies = new Cookies();

const history = createHashHistory();
let rand = require("random-key");
let isLoading = "false",
  limit = 6;
let now = moment();
class ViewDetail extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      index: 0,
      direction: null,
      menuList: "",
      currentDeals: [],
      show: false,
      alertMessage: "",
      limit: 22,
      perPage: 22,
      total: "",
      dealID: [],
      topDealHighlights: "",
      modelShow: false,
      quantity: '',
      recipientEmail: '',
      recipientName: '',
      personalMessage: '',
      wdith: 0,
      height: 0,
      notifications: '',
      hover: false,
      default_city: '',
    };

    this.handleSearch = this.handleSearch.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.addToCart = this.addToCart.bind(this);

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);

    this.pagination = this.pagination.bind(this);
    this.handleAttributes = this.handleAttributes.bind(this);
    this.addToCartAttribute = this.addToCartAttribute.bind(this);

    this.handleChange = this.handleChange.bind(this);
    this.submitAsGift = this.submitAsGift.bind(this);
  }

  hoverOn = (e) => {
    this.setState({ hover: true, hoverID: e.target.attributes.getNamedItem("data-id").value });
  }

  hoverOff = (e) => { 
    this.setState({ hover: false, hoverID: e.target.attributes.getNamedItem("data-id").value });    
  }

  submitAsGift(e){
    let validate = this.validate();
    if(validate){
      if(!isEmpty(this.state.topDeal.child_deals)){
        this.addToCartAttribute(e);
      }else{
        this.addToCart(e);
      }
    }
  }

  validate = () => {
    let response = true;

    if(!this.state.recipientName){
      response = false;
      this.setState({recipientNameError: 'red'});
    }

    if(!this.state.recipientEmail){
      response = false;
      this.setState({recipientEmailError: 'red'});
    }

    if(!this.state.quantity){
      response = false;
      this.setState({quantityError: 'red'});
    }

    if(!this.state.personalMessage){
      response = false;
      this.setState({personalMessageError: 'red'});
    }

    return response;
  }

  closeModel = () => {
    this.setState({modelShow: false});
  }

  handleChange(e){
    if (`this.state.${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({[e.target.name] : e.target.value});
  }

  handleModel = () => {
    if(!isEmpty(this.state.topDeal.child_deals)){
      if (this.state.dealID.length > 0) {
        this.setState({modelShow: true});
      }else{
        this.setState({ show: true });
        this.setState({ error: "Please choose minimum one option." });
        this.setState({modelShow: false});
      }
    }else{
      this.setState({
        quantity: '',
        recipientName: '',
        recipientEmail: '',
        personalMessage: '',
        quantityError: '',
        recipientNameError: '',
        recipientEmailError: '',
        personalMessageError: '',
      });
      this.setState({modelShow: true});
    }
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  addToCart = (e) => {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    isLoading = "true";
    if (isEmpty(cookies.get("token"))) {
      let d = new Date();
      d.setTime(d.getTime() + 480 * 60 * 1000);
      cookies.set("token", moment().format("x"), { path: "/", expires: d });
    }

    let dealID = this.props.route.match.params.dealID
      ? this.props.route.match.params.dealID.split("-")
      : "";

    if (dealID[0] !== "" && cookies.get("token") !== "") {
      this.props.addToCart({
        dealID: (this.state.topDeal.child_deals) ? e.target.attributes.getNamedItem("data-id").value : this.state.topDeal.dealID,
        userKey: cookies.get("token"),
        quantity: (this.state.quantity) ? this.state.quantity : 1,
        sendAsGift: (this.state.recipientName) ? 1 : 0,
        recipientName: this.state.recipientName,
        recipientEmail: this.state.recipientEmail,
        personalMessage: this.state.personalMessage,
        marketID: (siteData && siteData.default_city) ? siteData.default_city : '',
      });
    }
  }

  handleAttributes = e => {
    const dealID = this.state.dealID;

    let index;

    if (e.target.checked) {
      dealID.push(e.target.value);
    } else {
      index = dealID.indexOf(e.target.value);
      dealID.splice(index, 1);
    }


    this.setState({ dealID: dealID });
    this.setState({ error: "" });
  };


  addToCartAttribute = e => {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    e.preventDefault();
    if (this.state.dealID.length > 0) {
      this.state.dealID.map((data, index) => {
        isLoading = "true";
        if (isEmpty(cookies.get("token"))) {
          let d = new Date();
          d.setTime(d.getTime() + 480 * 60 * 1000);
          cookies.set("token", moment().format("x"), { path: "/", expires: d });
        }

        if (data !== "" && cookies.get("token") !== "") {
          this.props.addToCart({
            dealID: data,
            userKey: cookies.get("token"),
            quantity: (this.state.quantity) ? this.state.quantity : 1,
            sendAsGift: (this.state.recipientName) ? 1 : 0,
            recipientName: this.state.recipientName,
            recipientEmail: this.state.recipientEmail,
            personalMessage: this.state.personalMessage,
            marketID: (siteData && siteData.default_city) ? siteData.default_city : '',
          });
        }
      });
    } else {
      this.setState({ show: true });
      this.setState({ error: "Please choose minimum one option." });
    }
  };

  pagination = () => {
    isLoading = "true";

    limit = limit + this.state.perPage;
    const postData = {
      limit: limit,
      giftvoucher: "no",
    };

    this.props.currentDealList(postData);
  };

  handlePageChange = page => {
    isLoading = "true";
    this.setState({
      currentPage: page
    });
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    let default_city = '';
    if(!this.state.default_city || this.state.default_city != siteData.default_city){
      if(siteData && siteData.default_city){
        default_city = siteData.default_city;
      }
    }

    const postData = {
      page: page,
      latitude: "26.846695",
      longitude: "80.946167",
      limit: this.state.limit,
      geolocation: "off",
      giftvoucher: "no",
    };

    if(default_city){
      postData.cityID = default_city;
    }

    let affiliateID = this.props.route.match.params.affiliateID
      ? this.props.route.match.params.affiliateID
      : "";

    let dealID = this.props.route.match.params.dealID
      ? this.props.route.match.params.dealID.split("-")
      : "";
    if (dealID[0] !== "") {
      let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
      this.props.dealDetail({dealID: parseInt(dealID[0]) ? dealID[0] : this.props.route.match.params.dealID, affiliateID: affiliateID, cityID: (siteData.default_city) ? siteData.default_city : ""});
      if (cookies.get("affiliateID") != affiliateID && affiliateID != "") {
        cookies.remove("affiliateID");
      }
      if (affiliateID != "") {
        if (isEmpty(cookies.get("affiliateID"))) {
          let d = new Date();
          d.setTime(d.getTime() + 480 * 60 * 1000);
          cookies.set(
            "affiliateID",
            {
              affiliateID: affiliateID,
              dealID: dealID[0]
            },
            { path: "/", expires: d }
          );
        }
      }
    }

    this.props.currentDealList(postData);
    // this.props.topDeals(postData);
  };

  onSearch = val => {
    this.handleSearch(val);
  };

  handleSearch(val) {
    const postData = {
      page: this.state.currentPage,
      latitude: this.props.coords ? this.props.coords.latitude : "26.846695",
      longitude: this.props.coords ? this.props.coords.longitude : "80.946167",
      search: val,
      limit: this.state.limit,
      geolocation: "off",
      giftvoucher: "no",
    };

    if (val.length !== 0) {
      this.props.currentDealList(postData);
    } else {
      this.handlePageChange();
    }
  }

  componentWillMount() {
    this.props.clearAlert();
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData){
      this.setState({siteDomain: siteData.siteDomain, default_city: siteData.default_city,});
    }
    this.handleDismiss();
    this.handlePageChange(1);
  }

  componentDidMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData){
      if(siteData.default_city){
        this.setState({
          notifications: siteData.notifications,
        });
      }
    }
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.themeData){
      if(nextProps.themeData.button){
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          text_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }
    }

    // Top Deal
    if (this.props.topDeal != nextProps.topDeal) {
      if (nextProps.topDeal) {
        isLoading = "false";
        this.setState({ topDeal: nextProps.topDeal });

        if(nextProps.topDeal.offer_meta_title !== '' && nextProps.topDeal.offer_meta_title !== null){
          document.title = nextProps.topDeal.offer_meta_title;
        }

        if(nextProps.topDeal.offer_description  != '' && nextProps.topDeal.offer_description !== null){
          let meta = document.querySelector("meta[name*='description']");
          meta.content = nextProps.topDeal.offer_description;
        }

        if(nextProps.topDeal.highlights !== ''){
          this.setState({ topDealHighlights: (nextProps.topDeal.highlights) ? JSON.parse(nextProps.topDeal.highlights) : '' });
        }
        
      }
    }
    // current deal
    if (this.props.curDeal != nextProps.curDeal) {
      if (nextProps.curDeal) {
        isLoading = "false";
        this.setState({ total: nextProps.curDeal.total });
        this.setState({ curDeal: nextProps.curDeal.data });
      }
    }

    if (this.props.couponStatus != nextProps.couponStatus) {
      if (nextProps.couponStatus) {
        let dealID = this.props.route.match.params.dealID
          ? this.props.route.match.params.dealID
          : "";
        if (dealID !== "") {
          isLoading = "false";
          history.push("/voucher/" + dealID +"/free");
        }
      }
    }

    if (this.props.cartStatus != nextProps.cartStatus) {
      if (nextProps.cartStatus) {
        isLoading = "false";
        this.closeModel();
        this.setState({ cartStatus: nextProps.cartStatus });
        history.push('/cart');
      }
    }

    if (this.props.cartError !== nextProps.cartError) {
      if (nextProps.cartError) {
        isLoading = "false";
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.cartError);
        isLoading = "false";
      }
    }

    if (this.props.message !== nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
  }

  handleSelect(selectedIndex, e) {
    this.setState({
      index: selectedIndex,
      direction: e.direction
    });
  }

  handleSubmit = dealID => {
    isLoading = "true";
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    this.props.dealDetail({dealID: dealID, affiliateID: "", cityID: (siteData.default_city) ? siteData.default_city : ""});
  };

  generateCoupon = dealID => {
    isLoading = "true";
    // this.props.generateCoupon({ dealID: dealID });
     history.push("/voucher/" + dealID +"/free");
  };

  render() {
    const { index, direction } = this.state;
    let images = (this.state.topDeal) ? this.state.topDeal.dealImages : '';

    // Timer option
    let timerOption = 'no';
    if(this.state.topDeal){
      let dt1 = new Date(this.state.topDeal.today_date); 
      let dt2 = new Date(this.state.topDeal.expiry_date); 

      let diff =(dt2.getTime() - dt1.getTime()) / 1000;
      diff /= (60 * 60);

      if(diff <= parseInt(this.state.topDeal.timerStartInHour) && this.state.topDeal.timerStartInHour > 0){
        timerOption = 'yes';
      }

      if(this.state.topDeal.timerStartInHour === '' ||  this.state.topDeal.timerStartInHour == 0){
        timerOption = 'yes';
      } 
    }

    // Internet Explorer 6-11
    const isIE = /*@cc_on!@*/false || !!document.documentMode;

    // Edge 20+
    const isEdge = !isIE && !!window.StyleMedia;
    
    let currentDeals, upDeal, totalDeal, position, parDealID;
    if (!isEmpty(this.state.curDeal)) {
      totalDeal = this.state.curDeal.length;

      if(totalDeal > 2){
        position = 2;
      }else{
        position = totalDeal - 1;
      }
      if(!isEmpty(this.props.route.match.params) && this.props.route.match.params.dealID){
        // parDealID = this.props.route.match.params.dealID.split("-");
        // parDealID = parDealID[0];
        parDealID = this.props.route.match.params.dealID;
      }else{
        parDealID = '';
      }

      currentDeals = this.state.curDeal.map((deal, index) => {
        if(index >= 0 && deal.offer_url != parDealID){
          return <React.Fragment key={Math.random() + index}>
          {(index == position) ?
            <React.Fragment>
            
            <Col lg={4} md={4} sm={4} xs={12} key={Math.random() + index}>
              <div className="deal-container shadow">
                <div className="deal-image">
                  <Image
                    src={
                      deal.dealImage ? deal.imageurl + deal.dealImage : noImg
                    }
                    alt={deal.img_alt_text}
                    title={deal.img_text}
                    description={deal.img_desc}
                    responsive
                  />
                </div>
                <h2 className="dealname">{deal.mainDealText}</h2>
                <div className="merchant">
                  {(deal.useProdName == 0) ? deal.merchantName : (deal.prodName) ? deal.prodName : deal.merchantName}
                </div>
                <div className="prices">
                  {deal.offerPrice > 0 ? (
                    deal.offerPrice == deal.retailPrice ? (
                      <span className="percent" />
                    ) : (
                      <span className="percent" style={{ color: this.state.text_color }}>
                        -{(deal.offerPrice / deal.retailPrice * 100).toFixed(2)}%
                      </span>
                    )
                  ) : (
                    <span className="percent" style={{ color: this.state.text_color }}>FREE</span>
                  )}
                  <span className="price">
                    <i className="fa fa-usd" />
                    {deal.retailPrice}
                  </span>
                  <span className="current">
                    <i className="fa fa-usd" />
                    {deal.offerPrice}
                  </span>
                </div>
                <div className="short-disc">
                  {deal.writeUp
                    ? ReactHtmlParser(deal.writeUp.substring(0, 180))
                    : ""}
                </div>
                <div className="deal-footer">
                  {(isIE == false && isEdge == false) ?
                  <Link
                    to={(deal.offer_url) ? `/deals-detail/${deal.offer_url}` : `/deals-detail/${deal.dealID}-${deal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`}
                    onClick={this.handleSubmit.bind(this, deal.dealID)}
                    replace
                    className="btn btn-deal"
                    style={{backgroundColor: (this.state.hover && this.state.hoverID == deal.dealID) ? this.state.mouseover_color : this.state.button_color}}
                    data-id = {deal.dealID}
                    onMouseEnter={this.hoverOn} 
                    onMouseLeave={this.hoverOff}
                  >
                    View
                  </Link>
                  :
                  <Link
                    to={(deal.offer_url) ? `/deals-detail/${deal.offer_url}` : `/deals-detail/${deal.dealID}-${deal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`}
                    onClick={this.handleSubmit.bind(this, deal.dealID)}
                    replace
                    className="btn btn-deal"
                    style={{backgroundColor: (this.state.hover && this.state.hoverID == deal.dealID) ? this.state.mouseover_color : this.state.button_color}}
                    data-id = {deal.dealID}
                  >
                    View
                  </Link>
                  }
                </div>
              </div>
            </Col>
            {(this.state.notifications) &&
              this.state.notifications.map((data, index) => 
                (data.position == 'third_position') &&
                  <Col lg={4} md={4} sm={4} xs={12} key={Math.random() + index}>
                    <div className="deal-container shadow">
                      <React.Fragment>
                      {(data.displayimage != '' || data.mobileappdisplay_image != '') ?
                        (this.state.width > 480 && data.remove_image == 1) ?
                          <a href={data.display_image_link} target="_blank"><Image src={data.displayimage} /></a>
                        :(this.state.width < 480 && data.remove_mobile_app_image == 1) ?
                        <a href={data.display_image_link} target="_blank"><Image src={data.mobileappdisplay_image} /></a>
                        :
                        <React.Fragment>{(data.message != '') ? ReactHtmlParser(data.message) : ''}</React.Fragment>
                      :
                        <React.Fragment>{(data.message != '') ? ReactHtmlParser(data.message) : ''}</React.Fragment>
                      }
                      </React.Fragment>
                    </div>
                  </Col>
              )
            }
            </React.Fragment>
          :
          <Col lg={4} md={4} sm={4} xs={12} key={Math.random() + index}>
          <div className="deal-container shadow">
            <div className="deal-image">
              <Image
                src={
                  deal.dealImage ? deal.imageurl + deal.dealImage : noImg
                }
                alt={deal.img_alt_text}
                title={deal.img_text}
                description={deal.img_desc}
                responsive
              />
            </div>
            <h2 className="dealname">{deal.mainDealText}</h2>
            <div className="merchant">
              {(deal.useProdName == 0) ? deal.merchantName : (deal.prodName) ? deal.prodName : deal.merchantName}
            </div>
            <div className="prices">
              {deal.offerPrice > 0 ? (
                deal.offerPrice == deal.retailPrice ? (
                  <span className="percent" />
                ) : (
                  <span className="percent" style={{ color: this.state.text_color }}>
                    -{(deal.offerPrice / deal.retailPrice * 100).toFixed(2)}%
                  </span>
                )
              ) : (
                <span className="percent" style={{ color: this.state.text_color }}>FREE</span>
              )}
              <span className="price">
                <i className="fa fa-usd" />
                {deal.retailPrice}
              </span>
              <span className="current">
                <i className="fa fa-usd" />
                {deal.offerPrice}
              </span>
            </div>
            <div className="short-disc">
              {deal.writeUp
                ? ReactHtmlParser(deal.writeUp.substring(0, 180))
                : ""}
            </div>
            <div className="deal-footer">
              {(isIE == false && isEdge == false) ?
                <Link
                  to={(deal.offer_url) ? `/deals-detail/${deal.offer_url}` : `/deals-detail/${deal.dealID}-${deal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`}
                  onClick={this.handleSubmit.bind(this, deal.dealID)}
                  replace
                  className="btn btn-deal"
                  style={{backgroundColor: (this.state.hover && this.state.hoverID == deal.dealID) ? this.state.mouseover_color : this.state.button_color}}
                  data-id = {deal.dealID}
                  onMouseEnter={this.hoverOn} 
                  onMouseLeave={this.hoverOff}
                >
                  View
                </Link>
                :
                <Link
                  to={(deal.offer_url) ? `/deals-detail/${deal.offer_url}` : `/deals-detail/${deal.dealID}-${deal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`}
                  onClick={this.handleSubmit.bind(this, deal.dealID)}
                  replace
                  className="btn btn-deal"
                  style={{backgroundColor: (this.state.hover && this.state.hoverID == deal.dealID) ? this.state.mouseover_color : this.state.button_color}}
                  data-id = {deal.dealID}
                >
                  View
                </Link>
              }
            </div>
          </div>
        </Col>
          }
        </React.Fragment>
      }});
    }

    const style = {
      width: "95%",
      height: "450px",
    };

    var points = [
      { lat: 26.851310, lng: -77.01 },
    ];
    var bounds = new this.props.google.maps.LatLngBounds();
    for (var i = 0; i < points.length; i++) {
      bounds.extend(points[i]);
    }

    return (
      <React.Fragment>
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="container">
          {this.state.show &&
            this.state.alertMessage !== "" && (
              <div className="row">
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>Message:</strong> {this.state.alertMessage}
                  </Alert>
                </div>
              </div>
            )}
          {!isEmpty(this.state.topDeal) ? (
            <Row>
              <Col lg={8} md={8} sm={6} xs={12} >
                <Carousel
                  activeIndex={index}
                  direction={direction}
                  onSelect={this.handleSelect}
                >
                  {!isEmpty(this.state.topDeal.dealImages) ? (
                    this.state.topDeal.dealImages.map((topImg, index) => (
                      <Carousel.Item key={'crimg'+index}>
                        <Image responsive src={topImg.dealID} alt={topImg.img_alt_text} title={topImg.img_text} description={topImg.img_desc} />
                      </Carousel.Item>
                    ))
                  ) : (
                    <Carousel.Item>
                      <Image responsive src={noImg} />
                    </Carousel.Item>
                  )}
                </Carousel>
                <br />
                <Tabs
                  activeKey={this.state.key}
                  onSelect={this.handleTabs}
                  id="controlled-tab-example"
                >
                  <Tab eventKey={1} title="Details">
                    {this.state.topDeal.writeUp
                      ? ReactHtmlParser(this.state.topDeal.writeUp)
                      : ""}
                  </Tab>
                  <Tab eventKey={2} title="Fine Print">
                    <h4>{this.state.topDeal.voucherText}</h4>
                    {this.state.topDeal.termsAndConditions
                      ? ReactHtmlParser(this.state.topDeal.termsAndConditions)
                      : ""}
                  </Tab>
                  <Tab eventKey={3} title="Location(s)">
                    <Row>
                      {(this.state.topDeal.dealLocation) &&
                        this.state.topDeal.dealLocation.map((data, index) =>
                          <Col md={4} xs={12} key={data.dealLocationID}>
                            <Row>
                              <Col md={2} xs={12}>
                                <span className="text-danger text-center" style={{fontSize: '35px'}}><i className="fa fa-map-marker"></i></span>
                              </Col>
                              <Col md={10} xs={12}>
                                <span><b>{this.state.topDeal.merchantName}</b></span>
                                <br/><span>{data.locAddress1}</span>
                                {(data.locAddress2) &&
                                  <span><br/>{data.locAddress2}</span>
                                }
                                <br/><span>{data.locCity}, {data.locState}</span>
                                <br/><span>{data.locCountry}</span>
                                {(data.locPhone) &&
                                  <span><br/>{data.locPhone}</span>
                                } 
                              </Col>
                            </Row>
                          </Col>
                        )
                    }
                    </Row>
                    <Row>
                      <Col md={12} xs={12}>
                        <br />
                        <Map
                          google={this.props.google}
                          style={style}
                          initialCenter={{
                              lat: (this.state.topDeal.dealLatLong && this.state.topDeal.dealLatLong[0]) ? this.state.topDeal.dealLatLong[0].locLatitude : '',
                              lng: (this.state.topDeal.dealLatLong && this.state.topDeal.dealLatLong[0]) ? this.state.topDeal.dealLatLong[0].locLongitude : '',
                          }
                          }
                          zoom={2}
                        >                       
                          {(this.state.topDeal.dealLatLong) &&
                            this.state.topDeal.dealLatLong.map((data, key) => 
                              <Marker key={data.locLatitude+key} position={{lat: data.locLatitude, lng: data.locLongitude}} />
                            )
                          }
                        </Map>
                      </Col>
                      </Row>
                  </Tab>
                  {this.state.topDeal.question_switch == 'enable' ? (
                  <Tab eventKey={4} title="Question">
                    {isEmpty(localStorage.getItem("user")) ? (
                      <Row>
                        <Col md={12} xs={12} className="text-center">
                          <h3 className="timer">
                            You must be <Link replace to="/login">logged in</Link> to
                            ask your question
                          </h3>
                        </Col>
                      </Row>
                    ) : (
                      <Question dealID={this.state.topDeal.dealID} buttonColor={(this.state.button_color) ? this.state.button_color : '#77C84E'} />
                    )}
                  </Tab>):('')}
                  {this.state.topDeal.reviews_switch == 'enable' ? (
                  <Tab eventKey={5} title="Reviews">
                    <div>
                      <ReviewList dealID={this.state.topDeal.dealID} />
                      <hr />
                      {isEmpty(localStorage.getItem("user")) ? (
                        <Row>
                          <Col md={12} xs={12} className="text-center">
                            <h3 className="timer">
                              You must be <Link replace to="/login">logged in</Link> to
                              ask your question
                            </h3>
                          </Col>
                        </Row>
                      ) : (
                        <Reviews dealID={this.state.topDeal.dealID} buttonColor={(this.state.button_color) ? this.state.button_color : '#77C84E'} />
                      )}
                    </div>
                  </Tab>):('')}
                </Tabs>
              </Col>
              <Col lg={4} md={4} sm={6} xs={12} className="pl-0">
                <div className="bg-white bannerDealcontainer shadow text-center">
                  <div className="bannerDeal">
                    <h2 className="dealname">
                      {this.state.topDeal.mainDealText}
                    </h2>

                    <div className="deals-price">
                      <span className="price">
                        ${this.state.topDeal.offerPrice}
                      </span>
                      <h5 className="merchant text-center">
                      {(this.state.topDeal.useProdName == 0) ? this.state.topDeal.merchantName : (this.state.topDeal.prodName) ? this.state.topDeal.prodName : this.state.topDeal.merchantName}
                      </h5>
                      {(this.state.topDeal.sold_out == true) ?
                      <React.Fragment>
                        <Link
                          to="#"
                          replace
                          className="view-button btn btn-deal"
                          style={{backgroundColor: this.state.button_color}}
                        >
                          Sold Out
                        </Link>
                      </React.Fragment>
                      :
                      <React.Fragment>
                      {!isEmpty(this.state.topDeal.child_deals) ? (
                        <div>
                          {this.state.topDeal.child_deals.map((deal, index) => (
                            <Row>
                              <Col md={12} xs={12} className="text-left">
                                <FormGroup>
                                  {now.isBefore(deal.startDateTime) ? (
                                    <Checkbox
                                      onClick={this.handleAttributes}
                                      value={deal.dealID}
                                      disabled
                                    >
                                      ${deal.offerPrice} - {deal.dealText}
                                    </Checkbox>
                                  ) : (
                                    <Checkbox
                                      onClick={this.handleAttributes}
                                      value={deal.dealID}
                                    >
                                      ${deal.offerPrice} - {deal.dealText}
                                    </Checkbox>
                                  )}
                                </FormGroup>
                              </Col>
                            </Row>
                          ))}
                          {(isIE == false && isEdge == false) ?
                          <Link
                            to=""
                            replace
                            className="view-button btn btn-deal"
                            onClick={this.addToCartAttribute}
                            style={{backgroundColor: (this.state.hover && this.state.hoverID == 'Add To Cart') ? this.state.mouseover_color : this.state.button_color}}
                            data-id = {'Add To Cart'}
                            onMouseEnter={this.hoverOn} 
                            onMouseLeave={this.hoverOff}
                          >
                            Add To Cart 
                          </Link>
                          :
                          <Link
                            to=""
                            replace
                            className="view-button btn btn-deal"
                            onClick={this.addToCartAttribute}
                            style={{backgroundColor: (this.state.hover && this.state.hoverID == 'Add To Cart') ? this.state.mouseover_color : this.state.button_color}}
                            data-id = {'Add To Cart'}
                            onMouseEnter={this.hoverOn} 
                            onMouseLeave={this.hoverOff}
                          >
                            Add To Cart 
                          </Link>
                          }
                        </div>
                      ) : (
                        <div>
                          {now.isBefore(this.state.topDeal.startDateTime) ? (
                            <div>
                              {(isIE == false && isEdge == false) ?
                              <a 
                                style={{backgroundColor: (this.state.hover && this.state.hoverID == this.state.topDeal.dealID) ? this.state.mouseover_color : this.state.button_color}}
                                data-id = {this.state.topDeal.dealID}
                                onMouseEnter={this.hoverOn} 
                                onMouseLeave={this.hoverOff} 
                                className="view-button btn btn-danger"
                              >
                                Upcoming Deal
                              </a>
                              :
                              <a 
                                style={{backgroundColor: (this.state.hover && this.state.hoverID == this.state.topDeal.dealID) ? this.state.mouseover_color : this.state.button_color}}
                                data-id = {this.state.topDeal.dealID} 
                                className="view-button btn btn-danger"
                              >
                                Upcoming Deal
                              </a>
                              }
                            </div>
                          ) : (
                            <div>
                              {this.state.topDeal.proposal_type == 6 ? (
                                <React.Fragment>
                                {(isIE == false && isEdge == false) ?
                                <a
                                  className="view-button btn btn-deal"
                                  style={{backgroundColor: (this.state.hover && this.state.hoverID == this.state.topDeal.dealID) ? this.state.mouseover_color : this.state.button_color}}
                                  data-id = {this.state.topDeal.dealID}
                                  onMouseEnter={this.hoverOn} 
                                  onMouseLeave={this.hoverOff}
                                  onClick={
                                    this.state.topDeal.offerPrice > 0
                                      ? this.addToCart
                                      : this.generateCoupon.bind(
                                          this,
                                          this.state.topDeal.dealID
                                        )
                                  }
                                >
                                  {
                                    this.state.topDeal.offerPrice > 0
                                      ? 'Coupon'
                                      : 'Free Coupon'
                                  }
                                </a>
                                :
                                <a
                                  className="view-button btn btn-deal"
                                  style={{backgroundColor: (this.state.hover && this.state.hoverID == this.state.topDeal.dealID) ? this.state.mouseover_color : this.state.button_color}}
                                  data-id = {this.state.topDeal.dealID}
                                  onClick={
                                    this.state.topDeal.offerPrice > 0
                                      ? this.addToCart
                                      : this.generateCoupon.bind(
                                          this,
                                          this.state.topDeal.dealID
                                        )
                                  }
                                >
                                  {
                                    this.state.topDeal.offerPrice > 0
                                      ? 'Coupon'
                                      : 'Free Coupon'
                                  }
                                </a>
                                }
                                </React.Fragment>
                              ) : this.state.topDeal.proposal_type == 7 ? (
                                <React.Fragment>
                                {(isIE == false && isEdge == false) ?
                                <a
                                  href={this.state.topDeal.affiliatePurchaseUrl}
                                  target="_blank"
                                  className="view-button btn btn-deal"
                                  style={{backgroundColor: (this.state.hover && this.state.hoverID == this.state.topDeal.dealID) ? this.state.mouseover_color : this.state.button_color}}
                                  data-id = {this.state.topDeal.dealID}
                                  onMouseEnter={this.hoverOn} 
                                  onMouseLeave={this.hoverOff}
                                >
                                  Access
                                </a>
                                :
                                <a
                                  href={this.state.topDeal.affiliatePurchaseUrl}
                                  target="_blank"
                                  className="view-button btn btn-deal"
                                  style={{backgroundColor: (this.state.hover && this.state.hoverID == this.state.topDeal.dealID) ? this.state.mouseover_color : this.state.button_color}}
                                  data-id = {this.state.topDeal.dealID}
                                >
                                  Access
                                </a>
                                }
                                </React.Fragment>
                              ) : (
                                <React.Fragment>
                                {(isIE == false && isEdge == false) ?
                                <Link
                                  to={`/deals-detail/${
                                    this.state.topDeal.dealID
                                  }`}
                                  replace
                                  className="view-button btn btn-deal"
                                  onClick={this.addToCart}
                                  style={{backgroundColor: (this.state.hover && this.state.hoverID == this.state.topDeal.dealID) ? this.state.mouseover_color : this.state.button_color}}
                                  data-id = {this.state.topDeal.dealID}
                                  onMouseEnter={this.hoverOn} 
                                  onMouseLeave={this.hoverOff}
                                >
                                  Add To Cart
                                </Link>
                                :
                                <Link
                                  to={`/deals-detail/${
                                    this.state.topDeal.dealID
                                  }`}
                                  replace
                                  className="view-button btn btn-deal"
                                  onClick={this.addToCart}
                                  style={{backgroundColor: (this.state.hover && this.state.hoverID == this.state.topDeal.dealID) ? this.state.mouseover_color : this.state.button_color}}
                                  data-id = {this.state.topDeal.dealID}
                                >
                                  Add To Cart
                                </Link>
                                }
                                </React.Fragment>
                              )}
                            </div>
                          )}
                        </div>
                      )}
                      </React.Fragment>
                      }
                      {this.state.error ? (
                        <div className="col-lg-12">
                          <Notification type="danger">
                            <span>
                              <strong>Error:</strong> {this.state.error}
                            </span>
                          </Notification>
                        </div>
                      ) : null}
                    </div>
                    
                    <div className="text-center">
                        <div className="valueInfo shadow">
                          <div className="value">
                            <p className="value">${this.state.topDeal.retailPrice}</p>
                            <p className="text">Value</p>
                          </div>

                          <div className="discount">
                            <p className="value">{this.state.topDeal.saving_percent}%</p>
                            <p className="text">Discount</p>
                          </div> 

                          <div className="save">
                            <p className="value">${this.state.topDeal.saving_amount}</p>
                            <p className="text">SAVINGS</p>
                          </div>
                        </div>
                    </div>
                    <div className="social-icons margin-top">
                      <FacebookShareButton className="facebook" quote={this.state.topDeal.mainDealText} url={`${this.state.siteDomain}/#/deals-detail/${this.state.topDeal.dealID}-${this.state.topDeal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`}>
                        <FacebookIcon size={25} round={false} />
                      </FacebookShareButton>

                      <TwitterShareButton className="twitter" quote={this.state.topDeal.mainDealText} url={`${this.state.siteDomain}/#/deals-detail/${this.state.topDeal.dealID}-${this.state.topDeal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`}>
                        <TwitterIcon size={25} round={false} />
                      </TwitterShareButton>
                    </div>
                    {(this.state.topDeal.displayTimer == 1 && timerOption == "yes") &&
                      <div className="text-center timer">
                        <p>Time Remaining</p>
                        <i className="fa fa-clock-o" />{" "}
                        {this.state.topDeal.time_remaining}
                      </div>
                    }
                    {(this.state.topDeal.maxAsGift > 0 && this.state.topDeal.willCall == '1' && this.state.topDeal.sold_out == false) &&
                      <div className="text-center margin-top">
                        <Button bsStyle="success" style={{backgroundColor: this.state.button_color}} onClick={this.handleModel}><i className="fa fa-gift" aria-hidden="true"></i> Give as a gift</Button>
                      </div>
                    }
                  </div>
                </div>
                {(this.state.topDealHighlights.first !== '' || this.state.topDealHighlights.second !== '' || this.state.topDealHighlights.third !== '' || this.state.topDealHighlights.fourth !== '') ? (
                <div className="bg-white bannerDealcontainer shadow">
                    <h3>Deal Highlights</h3>
                  <div className="highlights">
                    <ul>
                      {(this.state.topDealHighlights.first) &&
                      <li key={Math.random()}><i className="fa fa-check" style={{color: this.state.button_color}}></i> {this.state.topDealHighlights.first}</li>
                      }
                      {(this.state.topDealHighlights.second) &&
                      <li key={Math.random()}><i className="fa fa-check" style={{color: this.state.button_color}}></i> {this.state.topDealHighlights.second}</li>
                      }
                      {(this.state.topDealHighlights.third) &&
                      <li key={Math.random()}><i className="fa fa-check" style={{color: this.state.button_color}}></i> {this.state.topDealHighlights.third}</li>
                      }
                      {(this.state.topDealHighlights.fourth) &&
                      <li key={Math.random()}><i className="fa fa-check" style={{color: this.state.button_color}}></i> {this.state.topDealHighlights.fourth}</li>
                      }
                    </ul>
                  </div>
                </div>): null}
                {(this.state.topDeal.showQuantityLeft && this.state.topDeal.showQuantityLeft =='yes') ? (
                  <div className="bg-white bannerDealcontainer shadow">
                    <h3>Quantity Left: {this.state.topDeal.quantity_remaining}</h3>
                  </div>) : null}
                {(this.state.topDeal.showPurchasedCount && this.state.topDeal.showPurchasedCount =='1') ? (
                    <div className="deal-purchased shadow">
                      <i className="fa fa-shopping-cart fa-3x" style={{color: this.state.button_color}}></i> <h3> {this.state.topDeal.purchase_count} Deals <span>Purchased</span> </h3>
                    </div>
                ) : null}
              </Col>
            </Row>
          ) : null}
        </div>
        
        <div className="container">
          {/*<div className="heading">
            <h2>Deals</h2>
          </div>*/}
          <Row>{currentDeals}</Row>
          {isEmpty(currentDeals) && !isLoading ? (
          <Row>
            <Col lg={12} md={12} sm={12} xs={12}>
              <Image src={noRecordFound} responsive style={{margin: 'auto'}}/>
            </Col>
          </Row>
        ):('')}
          {this.state.total > totalDeal ? (
            <Row>
              <Col
                lg={12}
                md={12}
                sm={12}
                xs={12}
                onClick={this.pagination}
                className="text-center"
              >
                <a 
                  style={{backgroundColor: (this.state.hover && this.state.hoverID == 'Load More') ? this.state.mouseover_color : this.state.button_color}}
                  data-id = {'Load More'}
                  onMouseEnter={this.hoverOn} 
                  onMouseLeave={this.hoverOff}
                  className="btn btn-deal"
                >
                  Load More Deals
                </a>
              </Col>
            </Row>
          ) : null}
        </div>
        <hr />
        <Modal show={this.state.modelShow} onHide={this.closeModel}>
          <Modal.Header closeButton>
            <Modal.Title>Send this as a gift!</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs={12} md={12}>
                You are purchasing item to send as a gift. If you wish to buy for yourself, you must purchase separately.
              </Col>
              <Col xs={12} md={12}>
                Your recipient will recieve an email on how to claim their gift after your account has been charged.
              </Col>
            </Row>
            <Row className="margin-top">
              <Col xs={12} md={6}>
              <Image
                src={
                  images ? images[0]['dealID'] : noImg
                }
                responsive
              />
              </Col>
              <Col xs={12} md={6}>
                <FormGroup>
                  <ControlLabel>Recipient Name</ControlLabel>
                  <FormControl
                    type="text"
                    name="recipientName"
                    value={this.state.value}
                    placeholder="Enter Name"
                    onChange={this.handleChange}
                    style={{borderColor:this.state.recipientNameError}}
                  />
                </FormGroup>
                <FormGroup>
                  <ControlLabel>Recipient Email</ControlLabel>
                  <FormControl
                    type="text"
                    name="recipientEmail"
                    value={this.state.value}
                    placeholder="Enter Email"
                    onChange={this.handleChange}
                    style={{borderColor:this.state.recipientEmailError}}
                  />
                </FormGroup>
                <FormGroup>
                  <ControlLabel>Quantity</ControlLabel>
                  <FormControl
                    type="number"
                    name="quantity"
                    value={this.state.value}
                    onChange={this.handleChange}
                    style={{borderColor:this.state.quantityError}}
                    max="10"
                    min="1"
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={12}>
                <FormGroup controlId="formControlsTextarea">
                  <ControlLabel>Personal Message</ControlLabel>
                  <FormControl 
                    componentClass="textarea" 
                    name="personalMessage" 
                    onChange={this.handleChange}
                    style={{borderColor:this.state.personalMessageError}}
                  />
                </FormGroup>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="success" style={{backgroundColor: this.state.button_color}} onClick={this.submitAsGift}>Add To Cart</Button>
            <Button onClick={this.closeModel}>Close</Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  }
}

ViewDetail.propTypes = {
  getDealList: PropTypes.func.isRequired,
  currentDealList: PropTypes.func.isRequired,
  dealDetail: PropTypes.func.isRequired,
  addToCart: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  dealList: state.frontReducer.dealList,
  topDeal: state.frontReducer.detail,
  curDeal: state.frontReducer.curDeal,
  error: state.frontReducer.error,
  cartError: state.frontReducer.cartError,
  cartStatus: state.frontReducer.cartStatus,
  couponStatus: state.frontReducer.couponStatus,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message
});

export default compose(
  GoogleApiWrapper((props) => ({
    apiKey: (props.mapkey) ? props.mapkey : '',
    }
  )),
  geolocated({
    positionOptions: {
      enableHighAccuracy: true
    },
    userDecisionTimeout: 5000
  }),
  connect(mapStateToProps, {
    getDealList,
    generateCoupon,
    renderAlert,
    clearAlert,
    currentDealList,
    dealDetail,
    addToCart
  })
)(ViewDetail);



// WEBPACK FOOTER //
// ./src/app/views/frontend/dashboard/ViewDetail.js